export const supportedFunctions = {
    func: params => {
        if (params.length > 0) {
            try {
                let _fn = params[0];
                if (typeof _fn === "string") {
                    _fn = eval(`(${_fn})`);
                    if (typeof _fn === "function") {
                        return _fn.apply(null, params.slice(1));
                    }
                }
            } catch (e) {
                console.log('e', e)
            }
        }
        return Number.NaN.toString()
    },
    uppercase: params => {
        return params.map(param => param.toUpperCase()).join("")
    },
    lowercase: params => {
        return params.map(param => param.toLowerCase()).join("")
    },
    concatenate: params => {
        return params.join("")
    },
    round: params => {
        if (params.length > 0) {
            let digits = params[1] ? Number(params[1]) || 2 : 2;
            let isSet = params[2] ? params[2] : "1";

            // const out = (Number.EPSILON + Number(params[0] || ""))?.toFixed(digits);
            const out = roundDecimalString(params[0], digits);
            if (paramAsBooleanIsSet(isSet)) {
                return out
            }
            return stripLastZeroesAfterDot(out)
        }
        return Number.NaN.toString()
    },
    ceil: (params) => {
        if (params.length > 0) {
            const value = params[0] || "0";
            const digits = Number(params[1]) || 0;
            const isSet = params[2] ? params[2] : "1";

            const out = ceilDecimalString(value, digits);

            if (paramAsBooleanIsSet(isSet)) {
                return out;
            }
            return stripLastZeroesAfterDot(out);
        }
        return Number.NaN.toString();
    },
    floor: (params) => {
        if (params.length > 0) {
            const value = params[0] || "0";
            const digits = Number(params[1]) || 0;
            const isSet = params[2] ? params[2] : "1";

            const out = floorDecimalString(value, digits);

            if (paramAsBooleanIsSet(isSet)) {
                return out;
            }
            return stripLastZeroesAfterDot(out);
        }
        return Number.NaN.toString();
    },
    add: params => {
        return params.reduce((out, param) => {
            if (!isNaN(Number(out)) && !isNaN(Number(param))) {
                return toNumberString(Number(out) + Number(param))
            } else {
                return Number.NaN.toString()
            }
        }, "0")
    },
    multiply: params => {
        return params.reduce((out, param) => {
            if (!isNaN(Number(out)) && !isNaN(Number(param))) {
                return toNumberString(Number(out) * Number(param))
            } else {
                return Number.NaN.toString()
            }
        }, "1")
    },
    subtract: params => {
        params = [...params]
        const first = params.shift()
        const rest = supportedFunctions.add(params)
        if (!isNaN(Number(first)) && !isNaN(Number(rest))) {
            return toNumberString(Number(first) - Number(rest))
        }
        return Number.NaN.toString()
    },
    divide: params => {
        params = [...params]
        const first = params.shift()
        const rest = supportedFunctions.multiply(params)
        if (!isNaN(Number(first)) && !isNaN(Number(rest)) && Number(rest)) {
            return toNumberString(Number(first) / Number(rest))
        }
        return Number.NaN.toString()
    },
    pow: params => {
        if (!isNaN(Number(params[0] || "0")) && !isNaN(Number(params[1] || "0"))) {
            return toNumberString(
                Math.pow(Number(params[0] || "0"), Number(params[1] || "0"))
            )
        }
        return Number.NaN.toString()
    },
    lt: params => {
        return compare(params, "<")
    },
    lte: params => {
        return compare(params, "<=")
    },
    eq: params => {
        return compare(params, "=")
    },
    not: params => {
        return compare(params, "!=")
    },
    gte: params => {
        return compare(params, ">=")
    },
    gt: params => {
        return compare(params, ">")
    },
    if: params => {
        if (params.length < 2) {
            return ""
        }
        if (["", "0"].includes(params[0])) {
            return params[2] || ""
        }
        return params[1];
    },
    switch: params => {
        if (params.length < 3) {
            return "";
        }

        const expression = params[0];  // 비교할 값
        const pairs = params.slice(1, -1);  // 조건과 결과 쌍 (마지막 기본값 제외)
        const defaultValue = params[params.length - 1];  // 기본값

        for (let i = 0; i < pairs.length; i += 2) {
            if (expression === pairs[i]) {
                return pairs[i + 1];  // 매칭되는 경우 결과 반환
            }
        }

        return defaultValue;  // 아무 조건에도 맞지 않으면 기본값 반환
    },
    // custom
    max: params => {
        if (!params.length) {
            return Number.NaN.toString()
        }

        let numbers = params.filter((param) => param && !isNaN(Number(param)));
        return numbers.reduce((out, param) => {
            if (!isNaN(Number(out)) && !isNaN(Number(param))) {
                return Math.max(Number(out), Number(param)).toString()
            } else {
                return Number.NaN.toString()
            }
        }, numbers[0])
    },
    min: params => {
        if (!params.length) {
            return Number.NaN.toString()
        }
        let numbers = params.filter((param) => param && !isNaN(Number(param)));
        return numbers.reduce((out, param) => {
            if (!isNaN(Number(out)) && !isNaN(Number(param))) {
                return Math.min(Number(out), Number(param)).toString()
            } else {
                return Number.NaN.toString()
            }
        }, numbers[0])
    },
    sum: params => {
        try {
            if (!params.length) {
                return Number.NaN.toString()
            }

            // 숫자만 필터링
            let numbers = params.filter((param) => param && !isNaN(Number(param)));
            const result = numbers.reduce((out, param) => {
                if (!isNaN(Number(out)) && !isNaN(Number(param))) {
                    return (Number(out) + Number(param)).toString()
                } else {
                    return Number.NaN.toString()
                }
            }, 0);

            return typeof result === 'number'
                ? parseFloat(result) // 숫자인 경우에만 precision 적용
                : result; // 숫자가 아닐 경우 그대로 반환하거나, 기본값을 반환하도록 설정
        } catch (e) {
            return Number.NaN.toString()
        }
    },
    sumwithoutmaxmin: params => {
        try {
            if (!params.length) {
                return Number.NaN.toString();
            }

            if (params.length <= 2) {
                return "0"; // 최고점과 최저점을 제외할 수 없으므로 0 반환
            }

            // 숫자만 필터링
            let numbers = params.filter((param) => param && !isNaN(Number(param)));
            if (numbers.length <= 2) {
                return "0"; // 숫자가 2개 이하인 경우도 0 반환
            }

            // 숫자로 변환
            numbers = numbers.map((number) => Number(number));

            const max = Math.max(...numbers);
            const min = Math.min(...numbers);

            // 합계에서 최고점과 최저점을 제외
            const result = numbers.reduce((sum, num) => sum + num, 0) - max - min;

            return typeof result === 'number'
                ? parseFloat(result.toPrecision(12)) // 숫자인 경우에만 precision 적용
                : result; // 숫자가 아닐 경우 그대로 반환하거나, 기본값을 반환하도록 설정
        } catch (e) {
            return Number.NaN.toString()
        }
    },
    average: params => {
        try {
            if (!params.length) {
                return Number.NaN.toString();  // 빈 배열일 경우 NaN 반환
            }

            // 총합을 계산
            let numbers = params.filter((param) => param && !isNaN(Number(param)));
            const sum = numbers.reduce((out, param) => {
                if (!isNaN(Number(out)) && !isNaN(Number(param))) {
                    return (Number(out) + Number(param)).toString();
                } else {
                    return Number.NaN.toString();  // 숫자가 아니면 NaN 반환
                }
            }, 0);

            const result = (Number(sum) / numbers.length).toString();

            return typeof result === 'number'
                ? parseFloat(result.toPrecision(12)) // 숫자인 경우에만 precision 적용
                : result; // 숫자가 아닐 경우 그대로 반환하거나, 기본값을 반환하도록 설정
        } catch (e) {
            return Number.NaN.toString()
        }
    },
    averagewithoutmaxmin: params => {
        if (!params.length) {
            return Number.NaN.toString();  // 빈 배열일 경우 NaN 반환
        }

        if (params.length <= 2) {
            return "0";  // 숫자가 2개 이하인 경우, 제외할 수 없으므로 평균은 0
        }

        // 숫자만 필터링
        let numbers = params.filter((param) => param && !isNaN(Number(param)));
        if (numbers.length <= 2) {
            return "0";  // 숫자가 2개 이하인 경우, 제외할 수 없으므로 평균은 0
        }

        // 숫자로 변환
        numbers = numbers.map((number) => Number(number));

        const max = Math.max(...numbers);
        const min = Math.min(...numbers);

        // 최고점과 최저점을 제외한 합계
        const sumWithoutMaxMin = numbers.reduce((sum, num) => sum + num, 0) - max - min;

        // 남은 숫자의 개수로 나누어 평균 계산
        const average = sumWithoutMaxMin / (numbers.length - 2);

        return average.toString();
    },
    rank: params => {
        if (!params.length) {
            return Number.NaN.toString()
        }

        // 첫 번째 매개변수: 데이터 배열 (쉼표로 구분된 문자열로 받음)
        let data = params[0] ? params[0].split(',').map(Number) : [];

        // 두 번째 매개변수: 순위를 구할 값 (문자열로 받은 값을 숫자로 변환)
        let value = params[1] ? Number(params[1]) : NaN;

        // 세 번째 매개변수: 정렬 방식 ('asc' 또는 'desc')
        let order = params[2] ? params[2] : 'desc';

        // 데이터 배열이 비어 있거나, value가 숫자가 아닌 경우
        if (data.length === 0 || isNaN(value)) {
            return Number.NaN.toString();
        }

        // 배열을 정렬: 'desc'면 내림차순, 'asc'면 오름차순
        let sortedArr = [...data].sort((a, b) => order === 'asc' ? a - b : b - a);

        // 순위를 계산
        const rank = sortedArr.indexOf(value) + 1;
        return rank.toString();  // 문자열로 반환
    },

    /* array 를 첫번째 params 로 받는 수식*/
    array: params => {
        if (!params.length) {
            return Number.NaN.toString()
        }

        return params.reduce((out, param) => {
            if (out) {
                return `${out.trim()},${param.trim()}`;
            }
            return `${param.trim()}`;
        }, null);
    },
    arrayrank: params => {
        if (!params.length) {
            return Number.NaN.toString()
        }

        // 첫 번째 매개변수: 데이터 배열 (쉼표로 구분된 문자열로 받음)
        let data = params[0] ? params[0].split(',').map(Number) : [];

        // 두 번째 매개변수: 순위를 구할 값 (문자열로 받은 값을 숫자로 변환)
        let value = params[1] ? Number(params[1]) : NaN;

        // 세 번째 매개변수: 정렬 방식 ('asc' 또는 'desc')
        let order = params[2] ? params[2] : 'desc';

        // 데이터 배열이 비어 있거나, value가 숫자가 아닌 경우
        if (data.length === 0 || isNaN(value)) {
            return Number.NaN.toString();
        }

        // 배열을 정렬: 'desc'면 내림차순, 'asc'면 오름차순
        let sortedArr = [...data].sort((a, b) => order === 'asc' ? a - b : b - a);

        // 순위를 계산
        const rank = sortedArr.indexOf(value) + 1;
        return rank.toString();  // 문자열로 반환
    },
    arraycount: params => {
        try {
            if (!params.length) {
                return Number.NaN.toString();
            }

            let array = params[0] ? params[0].split(',') : [];

            // 두 번째 매개변수: 배열 내 필터 값
            let filter = params[1] ? params[1] : null;

            // 데이터 배열이 비어 있거나, value가 숫자가 아닌 경우
            if (array.length === 0) {
                return Number.NaN.toString();
            }

            const filters = array.filter((item) => filter ? item === filter : true);
            return filters.length;
        } catch (e) {
            return Number.NaN.toString()
        }
    },

    /* date */
    today: params => {
        if (params.length) {
            return Number.NaN.toString();
        }
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // 0부터 시작하므로 +1
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}${month}${day}`; // YYYYMMDD 형식으로 반환
    },

    calculatedaystotoday: params => {
        if (params.length !== 1 && params.length !== 2) {
            return Number.NaN.toString(); // 입력값이 없거나 여러 개이면 오류 처리
        }

        const baseDate = params[0];
        const format = params.length > 1 ? params[1] : null;

        // 기준일 유효성 검사 (YYYYMMDD 형식)
        if (!/^\d{8}$/.test(baseDate)) {
            return Number.NaN.toString();
        }

        // 기준일을 Date 객체로 변환
        const year = parseInt(baseDate.slice(0, 4));
        const month = parseInt(baseDate.slice(4, 6)) - 1; // 월은 0부터 시작
        const day = parseInt(baseDate.slice(6, 8));
        const base = new Date(year, month, day);

        if (isNaN(base)) {
            return Number.NaN.toString(); // 잘못된 날짜일 경우 오류 처리
        }

        // 오늘 날짜 가져오기
        const today = new Date();

        // 경과 일수 계산
        const diffTime = today - base; // 밀리초 차이
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // 일 단위로 변환

        // 포맷에 따라 결과 반환
        switch (format) {
            case 'days':
                return `${diffDays.toString()}일`;
            case 'years':
                return `${Math.floor(diffDays / 365.25).toString()}년`;
            case 'months':
                return `${Math.floor(diffDays / 30.4375).toString()}개월`;
            case 'weeks':
                return `${Math.floor(diffDays / 7).toString()}주`;
            case 'yearsMonthsDays': {
                const years = Math.floor(diffDays / 365.25);
                const remainingDaysAfterYears = diffDays % 365.25;
                const months = Math.floor(remainingDaysAfterYears / 30.4375);
                const days = Math.floor(remainingDaysAfterYears % 30.4375);
                return `${years}년 ${months}월 ${days}일`;
            }
            case 'yearsMonths': {
                const years = Math.floor(diffDays / 365.25);
                const remainingDaysAfterYears = diffDays % 365.25;
                const months = Math.floor(remainingDaysAfterYears / 30.4375);
                return `${years}년 ${months}월`;
            }
            case 'weeksDays': {
                const weeks = Math.floor(diffDays / 7);
                const days = diffDays % 7;
                return `${weeks}주 ${days}일`;
            }
            case 'monthsDays': {
                const months = Math.floor(diffDays / 30.4375);
                const days = Math.floor(diffDays % 30.4375);
                return `${months}개월 ${days}일`;
            }
            default:
                return `${diffDays.toString()}일`;
        }
    },

    calculatedaysbetween: params => {
        if (params.length < 2 || params.length > 3) {
            return Number.NaN.toString(); // 입력이 부족하거나 너무 많을 경우 오류
        }

        const [date1, date2, format] = params;

        // 날짜 유효성 검사
        if (!/^\d{8}$/.test(date1) || !/^\d{8}$/.test(date2)) {
            return Number.NaN.toString();
        }

        // 날짜 파싱
        const parseDate = (str) => {
            const year = parseInt(str.slice(0, 4));
            const month = parseInt(str.slice(4, 6)) - 1; // 0-based month
            const day = parseInt(str.slice(6, 8));
            return new Date(year, month, day);
        };

        const d1 = parseDate(date1);
        const d2 = parseDate(date2);

        if (isNaN(d1) || isNaN(d2)) {
            return Number.NaN.toString();
        }

        // 시간 차이 (절대값 기준)
        const diffTime = Math.abs(d2 - d1);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        switch (format) {
            case 'days':
                return `${diffDays}`;
            case 'years':
                return `${Math.floor(diffDays / 365.25)}`;
            case 'months':
                return `${Math.floor(diffDays / 30.4375)}`;
            case 'weeks':
                return `${Math.floor(diffDays / 7)}`;
            default:
                return `${diffDays}`; // 기본 출력
        }
    },

    // regex
    match: (params) => {
        // "^(19|20)\\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01])$"
        if (params.length < 2) return "0";
        try {
            const [text, pattern] = params;
            const regex = new RegExp(pattern);
            return regex.test(text) ? "1" : "0";
        } catch (e) {
            return "0";
        }
    },
    isemail: (params) => {
        if (!params.length) return "0";
        const email = params[0];
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email) ? "1" : "0";
    },
    iscellphone: (params) => {
        if (!params.length) return "0";
        const phone = params[0].replace(/-/g, "");
        const phoneRegex = /^01[016789]\d{7,8}$/;
        return phoneRegex.test(phone) ? "1" : "0";
    },
    isssn: (params) => {
        if (!params.length) return "0";
        const ssn = params[0].replace(/-/g, "");
        const ssnRegex = /^\d{6}[1-4]\d{6}$/;
        return ssnRegex.test(ssn) ? "1" : "0";
    },
    isbusinessnumber: (params) => {
        if (!params.length) return "0";

        const num = params[0].replace(/-/g, "");
        if (!/^\d{10}$/.test(num)) return "0";

        const checkSum = [1, 3, 7, 1, 3, 7, 1, 3, 5];
        let sum = 0;

        for (let i = 0; i < 9; i++) {
            sum += Number(num[i]) * checkSum[i];
        }

        sum += Math.floor((Number(num[8]) * 5) / 10);
        const checkDigit = (10 - (sum % 10)) % 10;

        return checkDigit === Number(num[9]) ? "1" : "0";
    }
}

export const supportedOperators = {
    "&": supportedFunctions.concatenate,
    "+": supportedFunctions.add,
    "-": supportedFunctions.subtract,
    "/": supportedFunctions.divide,
    "*": supportedFunctions.multiply,
    "^": supportedFunctions.pow,
    "<": supportedFunctions.lt,
    "<=": supportedFunctions.lte,
    "=": supportedFunctions.eq,
    ">=": supportedFunctions.gte,
    ">": supportedFunctions.gt
}

export function executeOperator(operator, parameters) {
    if (operator in supportedOperators) {
        return supportedOperators[operator](parameters)
    }
    return ""
}

export function executeFunction(name, parameters) {
    name = name.toLowerCase()
    if (name in supportedFunctions) {
        return supportedFunctions[name](parameters)
    }
    return ""
}

export function functionIsSupported(name) {
    name = name.toLowerCase()
    return name in supportedFunctions
}

export function toNumberString(n) {
    return Number(n.toFixed(10)).toString()
}

function paramAsBooleanIsSet(param) {
    param = (param || "").toLowerCase()
    return param && param !== "0" && param !== "false" && param !== "no"
}

function stripLastZeroesAfterDot(param) {
    if (param.match(/\./)) {
        return param.replace(/0+$/, "").replace(/\.$/, "")
    }
    return param
}

function compare(params, operator) {
    if (params.length < 2) {
        return "0"
    }
    const p0 = isNaN(Number(params[0])) ? params[0] : Number(params[0])
    const p1 = isNaN(Number(params[1])) ? params[1] : Number(params[1])
    if (operator.includes("=") && p0 === p1) {
        return "1"
    }
    if (operator.includes("<") && p0 < p1) {
        return "1"
    }
    if (operator.includes(">") && p0 > p1) {
        return "1"
    }
    return "0"
}

function roundDecimalString(value, digits) {
    if (!/^-?\d+(\.\d+)?$/.test(value)) {
        return Number.NaN.toString();
    }

    if (!value) {
        return Number.NaN.toString();
    }

    let [intPart, decPart = ""] = value.split(".");
    const isNegative = intPart.startsWith("-");
    if (isNegative) intPart = intPart.slice(1);

    // 패딩
    while (decPart.length <= digits) decPart += "0";

    const targetDigit = Number(decPart[digits] || "0");

    // 반올림 처리
    if (targetDigit >= 5) {
        // 반올림할 부분까지 잘라서 1 더함
        let roundTarget = intPart + decPart.slice(0, digits);
        let roundedNumber = (BigInt(roundTarget) + BigInt(1)).toString().padStart(intPart.length + digits, "0");

        const newInt = roundedNumber.slice(0, intPart.length);
        const newDec = roundedNumber.slice(intPart.length);
        return (isNegative ? "-" : "") + newInt + (digits > 0 ? "." + newDec : "");
    } else {
        // 반올림 없이 잘라서 리턴
        const newDec = decPart.slice(0, digits);
        return (isNegative ? "-" : "") + intPart + (digits > 0 ? "." + newDec : "");
    }
}

function ceilDecimalString(value, digits) {
    const isNegative = value.startsWith("-");
    const [intPartRaw, decPartRaw = ""] = value.replace("-", "").split(".");
    const decPart = decPartRaw.padEnd(digits + 1, "0");

    const baseStr = intPartRaw + decPart.slice(0, digits);
    const hasRemainder = decPart.slice(digits).split("").some(ch => ch !== "0");

    let result = BigInt(baseStr);
    if (!isNegative && hasRemainder) {
        result += BigInt(1);
    }

    const resultStr = result.toString().padStart(intPartRaw.length + digits, "0");
    const intPart = resultStr.slice(0, resultStr.length - digits);
    const fracPart = resultStr.slice(-digits);

    return (isNegative ? "-" : "") + (digits > 0 ? `${intPart}.${fracPart}` : intPart);
}

function floorDecimalString(value, digits) {
    const isNegative = value.startsWith("-");
    const [intPartRaw, decPartRaw = ""] = value.replace("-", "").split(".");
    const decPart = decPartRaw.padEnd(digits + 1, "0");

    const baseStr = intPartRaw + decPart.slice(0, digits);
    const hasRemainder = decPart.slice(digits).split("").some(ch => ch !== "0");

    let result = BigInt(baseStr);
    if (isNegative && hasRemainder) {
        result += BigInt(1);
    }

    const resultStr = result.toString().padStart(intPartRaw.length + digits, "0");
    const intPart = resultStr.slice(0, resultStr.length - digits);
    const fracPart = resultStr.slice(-digits);

    return (isNegative ? "-" : "") + (digits > 0 ? `${intPart}.${fracPart}` : intPart);
}